import { Tooltip } from '@mui/material';
import StyledButton from '../atoms/StyledButton';

const SaveButton = ({ isDisabledBtn, isEditMode, disableSave, onClick }) => {
    const Button = ({ disabled, children }) => (
        <StyledButton
            marginleft='10px'
            variant='contained'
            onClick={onClick}
            disabled={disabled}
            bold='true'
        >
            {children}
        </StyledButton>
    );

    // Disabled ususally due to loading state
    if (isDisabledBtn) {
        return <Button disabled>{isEditMode ? 'Save' : 'Create'}</Button>;
    }

    // Enabled & Create Mode
    if (!isEditMode) {
        return <Button disabled={false}>Create</Button>;
    }

    // save is NOT disabled
    if (!disableSave) {
        return <Button disabled={isDisabledBtn}>Save</Button>;
    }

    // disableSave is true
    return (
        <Tooltip
            title={
                'Dataset has changes disabled with the disableSave flag - please contact IT to unlock.'
            }
            placement='bottom'
        >
            <span>
                <Button disabled>Save</Button>
            </span>
        </Tooltip>
    );
};

export default SaveButton;
